<main>
  <h2>Übers PPS </h2>

  <div class="clr-row" >
    <div class="clr-col-4">
      <table class="table">
        <thead>
        <th class="left">Softwarekomponente</th>
        <th class="left">Version</th>
        </thead>
        <tbody>
        <tr>
          <td class="left">PPS</td>
          <td class="left">V {{ version_pps }}</td>
        </tr>
        <tr>
          <td class="left">npm</td>
          <td class="left">{{ version_npm }}</td>
        </tr>
        <tr>
          <td class="left">Node</td>
          <td class="left">{{ version_node }}</td>
        </tr>
        <tr>
          <td class="left">Clarity</td>
          <td class="left">{{ version_clarity }}</td>
        </tr>
        <tr>
          <td class="left">RMS Build</td>
          <td class="left">{{ build_number_rms }}</td>
        </tr>
        <tr>
          <td class="left">Auth Build</td>
          <td class="left">{{ build_number_auth }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="clr-col-8">
      <h2>Made with passion!</h2>
      <p>{{ production_mode ? "Das ist ein Production-Build." : "Das ist ein Development-Build." }}<br />
        (Target: {{ version_apiUrl }} Port: {{ version_port }})</p>
    </div>
  </div>
</main>
